  
import React from 'react';
import './AnswerOption.scss';

function AnswerOption(props) {
  
 let style, styleLabel;
 const pointer = props.pointer;  //block checking other questions

 if (props.isSelected && props.styleAnswer.flag) {
     
    style = {
        backgroundColor:"rgba(9, 122, 41, 0.2)",
        pointerEvents: pointer,
    };
    
    styleLabel = {
       // backgroundColor:"rgba(9, 122, 41, 0.2)",
        
    };
 }
 if (props.isSelected && !props.styleAnswer.flag) {
  style = {
        backgroundColor:"rgba(253, 7, 7, 0.2)",
        pointerEvents: pointer,
    }
 }

 if (!props.isSelected) {

    style = {
        pointerEvents: pointer,
    }
 }






 
    return (
        <li className="AnswerOption" style={style} >
            <input
             
            type="radio"
            className="radioCustomButton"
            name="radioGroup"
            id={props.number}
            value={props.answerType}
            disabled={props.answer}
            onChange={props.onAnswerSelected}
            
            />
            <label className="radioCustomLabel" htmlFor={props.number} style={styleLabel}>
        {props.answerContent} {/*props.number*/}
            </label>
        </li>
    )
}

export default AnswerOption;